import { jsx as _jsx } from "react/jsx-runtime";
import { Button, StatusBadge } from '@src/components/ui';
import { formatCurrencyForTable, getBooleanStatusBadgeColors } from '../utils/formatters';
export const createSalesRepColumns = () => [
    {
        key: 'sales_rep_id',
        header: 'Sales Rep ID',
        sortable: true,
        render: (rep) => rep.sales_rep_id || 'N/A',
    },
    {
        key: 'name',
        header: 'Name',
        sortable: true,
        render: (rep) => rep.name || 'N/A',
    },
    {
        key: 'email',
        header: 'Email',
        sortable: true,
        render: (rep) => rep.email || 'N/A',
    },
    {
        key: 'phone_number',
        header: 'Phone',
        render: (rep) => rep.phone_number || 'N/A',
    },
    {
        key: 'reports_to_name',
        header: 'Reports To',
        sortable: true,
        render: (rep) => rep.reports_to_name || 'N/A',
    },
    {
        key: 'territory_id',
        header: 'Territory',
        sortable: true,
        render: (rep) => rep.territory_id || 'N/A',
    },
    {
        key: 'clinic_count',
        header: 'Clinics',
        sortable: true,
        render: (rep) => String(rep.clinic_count ?? 0),
    },
    {
        key: 'is_active',
        header: 'Active',
        sortable: true,
        render: (rep) => {
            const { background, text } = getBooleanStatusBadgeColors(!!rep.is_active);
            return _jsx(StatusBadge, { label: rep.is_active ? 'Active' : 'Inactive', bgColor: background, color: text });
        },
    },
];
export const createSalesSummaryColumns = (groupBy, { onExport, exportDisabled = false } = {}) => [
    groupBy === 'sales_rep'
        ? {
            key: 'sales_rep_id',
            header: 'Sales Rep ID',
            sortable: true,
            render: (row) => (row.is_unassigned ? '—' : row.sales_rep_id || 'N/A'),
        }
        : {
            key: 'territory_id',
            header: 'Territory',
            sortable: true,
            render: (row) => (row.is_unassigned ? 'Unassigned' : row.territory_id || 'N/A'),
        },
    ...(groupBy === 'sales_rep'
        ? [{
                key: 'label',
                header: 'Sales Rep',
                sortable: true,
                render: (row) => row.label,
            }]
        : []),
    {
        key: 'order_count',
        header: 'Orders',
        sortable: true,
        render: (row) => String(row.order_count),
    },
    {
        key: 'gross_sales',
        header: 'Gross Sales',
        sortable: true,
        render: (row) => formatCurrencyForTable(row.gross_sales),
    },
    {
        key: 'discounts',
        header: 'Discounts',
        sortable: true,
        render: (row) => formatCurrencyForTable(row.discounts),
    },
    {
        key: 'net_sales',
        header: 'Net Sales',
        sortable: true,
        render: (row) => formatCurrencyForTable(row.net_sales),
    },
    {
        key: 'total',
        header: 'Order Total',
        sortable: true,
        render: (row) => formatCurrencyForTable(row.total),
    },
    ...(groupBy === 'sales_rep' && onExport
        ? [{
                key: 'actions',
                header: 'Actions',
                render: (row) => (row.is_unassigned || !row.rep_uuid
                    ? null
                    : (_jsx(Button, { variant: "secondaryV2", size: "small", label: "Export", disabled: exportDisabled, onClick: () => onExport(row) }))),
            }]
        : []),
];
